import { OrderCreatedDateFormInput } from "./components";
import { StockOrderDetailsFormProvider } from "./StockOrderDetailsFormProvider";

export const StockOrderDetailsForm = () => {
  return null;
};

StockOrderDetailsForm.Provider = StockOrderDetailsFormProvider;
StockOrderDetailsForm.OrderCreatedDateFormInput = OrderCreatedDateFormInput;
